import { useRouter } from "../../../hooks/router";
import React, { useEffect, useState, memo, useRef } from "react";
import ReactDOM from "react-dom";
import {
    add_movie_to_favourites,
    get_movie_info,
    get_related_movies,
    remove_movie_from_favourites,
    remove_watch_list
} from "../../../server/requests";

import RowList from "../../Row_List/RowList";
import ModalPlayerYoutube from "../../trailerPlayers/modal_yt_player/ModalPlayerYoutube";
import PlayerTrailer from "../../trailerPlayers/PlayerTrailer/PlayerTrailer";

import PosterInfo from "../../Header/PosterInfo";
import SeasonList from "../Seasons/SeasonList";
import EpisodesList from "../Episodes/EpisodesList";
import Loading from "../../Loading/Loading";
import PremiumField from "../PremiumField/PremiumField";
import PopUpPurchase from "../popUpPurchase/PopUpPurchase";

import './InfoMovie.scss'

import icon_favourites_active from "./images/favourite_active.png";
import icon_favourites from "./images/favourite.png";
import icon_watch_trailer from "../../Header/images/watch_now.png";
import icon_play from '../../Pages/Player/images/play.png'
import icon_purchase from '../../Pages/Player/images/dollar.png'
import icon_remove from '../../Pages/Player/images/remove.png'
import icon_refresh from './images/refresh.png'
import { translateWord, decrypt } from "../../Util/util";
import ErrorMessage from "../../AlertMessage/ErrorMessage";
import Notifications from "./Notifications";
import Modal from "../../Pages/Modal/Modal";


export default memo(function InfoMovie({ isGuest, appSettings }) {

    const router = useRouter()

    const [movieInfo, setMovieInfo] = useState('')
    const [relatedMovies, setRelatedMovies] = useState([])
    const [showTrailer, setShowTrailer] = useState(false)
    const [trailerId, setTrailerId] = useState('')
    const [activeSeasonIndex, setActiveSeasonIndex] = useState(0)
    const [showLoading, setShowLoading] = useState(true)
    const [favourite, setFavourite] = useState(false)
    const [season, setSeason] = useState('')
    const [showListRelated, setShowListRelated] = useState(true)
    const [episode, setEpisode] = useState('')
    const [watchList, setWatchList] = useState(false)
    const [showPopUpPurchase, setShowPopUpPurchase] = useState(false)
    const [purchaseType, setPurchaseType] = useState('')
    const [showLoginModal, setShowLoginModal] = useState(false)
    const [showPremium, setShowPremium] = useState({
        show: false,
        id: '',
        type: ''
    })
    const [message, setMessage] = useState({
        text: '',
        type: '',
        show: false
    })

    const movie_id = useRef('')

    useEffect(() => {

        if (router.query.id == movie_id.current) return

        setTrailerId('')
        setShowLoading(true)
        setShowListRelated(true)

        movie_id.current = router.query.id

        get_movie_info({ id: router.query.id }, data => {

            setMovieInfo(data)
            trailer_in_poster(data)

            if (data.favorites) setFavourite(true)
            else setFavourite(false)

            let _season;
            let _episode;

            if (data.seasons.length) {

                _season = data.seasons[0];
                _episode = _season.episodes[0];

                if (data.watched && data.watched.episodeId) {

                    for (let i = 0; i < data.seasons.length; i++) {

                        let episodes = data.seasons[i].episodes;

                        for (let j = 0; j < episodes.length; j++) {

                            if (data.watched.episodeId == episodes[j].id) {

                                _season = data.seasons[i];
                                _episode = episodes[j];

                            }

                        }

                    }

                }

                setSeason({ ..._season });
                setEpisode({ ..._episode });

            }

            setShowLoading(false)
        }, err => {
            setShowLoading(false)

            setMessage({
                text: 'Movie not found',
                type: 'error',
                show: true
            })
            hide_error_message()
            router.history.goBack()
        })

        get_related_movies({ id: router.query.id }, data => {
            setRelatedMovies(data)
            setTimeout(() => {
                setShowListRelated(false)
            }, 1000)
        }, err => console.log(err))

    }, [router.query, watchList])

    const callBackActiveSeasonIndex = (index) => {
        setActiveSeasonIndex(index)
    }

    const play_episode_info_field = (e) => {

        if (!movieInfo.canWatch) {

            if (movieInfo.content_monetization_type == 'tvod') {
                setMessage({
                    text: translateWord('You need to buy this movie or upgrade your subscription in order to watch it'),
                    type: 'error',
                    show: true
                })
                hide_error_message()
            } else {
                setShowPremium({
                    show: true,
                    id: movieInfo.id,
                    type: 'movie'
                })
            }

        } else {

            let season = movieInfo.seasons[activeSeasonIndex]

            router.push(
                `/player?type=tv_show&id=${movieInfo.id}&season=${season.number}&episode=${e.number}`
            )

            setEpisode(e)

        }

    }

    const trailer_in_poster = (data) => {

        let search
        let x


        if (data.trailer_source.indexOf("?") > -1) {
            search = data.trailer_source.split('?')[1];
            x = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',

                function (key, value) {

                    return key === "" ? value : decodeURIComponent(value)

                });

            setTrailerId(x.v);

        } else {

            if (data.trailer_source.indexOf("=") > -1) search = search.split("=")[1];
            else search = data.trailer_url

            setTrailerId(search);

        }

    }

    const add_remove_favourites = (e) => {

        if (!favourite) {
            add_movie_to_favourites({ movieId: e.id },
                () => setFavourite(true),
                err => {
                    setMessage({
                        text: err,
                        type: 'error',
                        show: true
                    })
                    hide_error_message()
                })
        } else {
            remove_movie_from_favourites({ movieId: e.id },
                () => setFavourite(false),
                err => {
                    setMessage({
                        text: err,
                        type: 'error',
                        show: true
                    })
                    hide_error_message()
                })
        }

    }

    const play_resume_btn = () => {
        if (movieInfo.canWatch) {
            if (movieInfo.content_monetization_type == 'free') {
                let _season;
                let _episode;

                if (movieInfo.seasons.length) {

                    _season = movieInfo.seasons[0];
                    _episode = _season.episodes[0];

                    if (movieInfo.watched && movieInfo.watched.episodeId) {

                        for (let i = 0; i < movieInfo.seasons.length; i++) {

                            let episodes = movieInfo.seasons[i].episodes;

                            for (let j = 0; j < episodes.length; j++) {

                                if (movieInfo.watched.episodeId == episodes[j].id) {
                                    _season = movieInfo.seasons[i];
                                    _episode = episodes[j];
                                }

                            }

                        }

                    }

                    setSeason({ ..._season });
                    setEpisode({ ..._episode });

                }

                router.push(
                    `/player?type=${movieInfo.type}&id=${movieInfo.id}${movieInfo.type == 'tv_show' ? '&season=' + _season.number + '&episode=' + _episode.number : ''}`
                )
            } else {
                setShowLoginModal(true)
            }
        } else {
            setShowPremium({
                show: true,
                id: movieInfo.id,
                type: 'movie'
            })
        }


    }

    const btn_purchase_movie = (type) => {
        setShowPopUpPurchase(true)
        setPurchaseType(type)
    }

    const btn_play_for_beginning = () => {

        let Season
        let Episode

        if (movieInfo.seasons.length) {
            setSeason({ ...movieInfo.seasons[0] })
            Season = movieInfo.seasons[0]
            setEpisode({ ...Season.episodes[0] })
            Episode = Season.episodes[0]
        }

        localStorage.setItem('begin', 'true')
        router.push(
            `/player?type=${movieInfo.type}&id=${movieInfo.id}${movieInfo.type == 'tv_show' ? '&season=' + Season.number + '&episode=' + Episode.number : ''}`
        )
    }

    const btn_remove_watch_list = () => {
        let body = {
            movieId: movieInfo.id,
            subId: JSON.parse(decrypt('user', localStorage.getItem('user'))).id
        }

        remove_watch_list(body, data => {
            // setWatchList()
            movie_id.current = ''
            setWatchList(!watchList)

        }, err => console.log(err))

    }

    const btn_watch_trailer = () => {

        // // remove this line
        // setShowTrailer(true)
        // return

        if (movieInfo.trailer_url) {
            setShowTrailer(true)
        } else {
            setMessage({
                text: 'Trailer not found',
                type: 'warning',
                show: true
            })
            hide_error_message()

        }
    }

    const hide_error_message = () => {
        setTimeout(() => {
            setMessage({
                text: '',
                type: '',
                show: false
            })
        }, 3000)
    }

    const callBackRentBuyMovie = () => {
        movie_id.current = ''
        setWatchList(!watchList)
        setShowPopUpPurchase(false)
    }

    return showLoading ?
        <Loading />
        : <>
            {showLoginModal ? ReactDOM.createPortal(
                <Modal
                    btnConfirm={() => {
                        localStorage.setItem('showLogin', true)
                        router.push('/auth')
                    }}
                    btnCancel={() => setShowLoginModal(false)}
                    btnConfirmText={translateWord('Sign in')}
                    btnCancelText={translateWord('Cancel')}
                    title={translateWord('Sign in to continue')}
                />, document.body) : null}
            {
                showPopUpPurchase ?
                    <PopUpPurchase
                        callBackRentBuyMovie={callBackRentBuyMovie}
                        title={purchaseType}
                        watchList={watchList}
                        setWatchList={setWatchList}
                        movie_info={movieInfo}
                        setShow={setShowPopUpPurchase}
                    />
                    : null
            }
            {showPremium.show ?
                ReactDOM.createPortal(<PremiumField id={showPremium.id} type={showPremium.type} close={() => {
                    setShowPremium({
                        show: false,
                        id: '',
                        type: ''
                    })
                    if (appSettings && appSettings.enable_payment) router.push(`/settings?a=payment&content_id=${movieInfo.id}${(movieInfo.type == 'tv_show' || movieInfo.type == 'movie' ? '&content_type=vod' : '')}`)

                }} />, document.body)

                : null}

            {/* {showTrailer ? <ModalPlayerYoutube trailerId={trailerId} setShowTrailer={setShowTrailer} /> : null} */}
            {showTrailer ? <PlayerTrailer movieInfo={movieInfo} setShowTrailer={setShowTrailer} isGuest={isGuest} /> : null}
            <ErrorMessage text={message.text} type={message.type} show={message.show} />

            <div className="poster poster_selected_movies conteiner ">
                <div className="container">
                    <div className="info_poster">

                        <PosterInfo elem={movieInfo} />

                        <div className="cast_genre">
                            {movieInfo.casts && movieInfo.casts.length ?

                                <h1>
                                    {translateWord('Cast', 'Starring')}:
                                    {movieInfo.casts.map((e, i) => {
                                        return i < 15 ? <span key={i}> {e.name}{i !== movieInfo.genres.length - 1 ? ',' : null}</span> : null
                                    })}
                                </h1>

                                : null}

                            {movieInfo.genres && movieInfo.genres.length ?
                                <h1>
                                    {translateWord('Genre')}:
                                    {movieInfo.genres.map((e, i) => {
                                        return <span key={i}> {translateWord(e.name)}{i !== movieInfo.genres.length - 1 ? ',' : null}</span>
                                    })}
                                </h1>
                                : null}

                            <div className="btns_movie_info">

                                {!movieInfo.canWatch && movieInfo.content_monetization_type == 'tvod' ?
                                    <div className="btns_purchase_group">
                                        <div className="btnMovieInfo buy" onClick={() => btn_purchase_movie('Buy')}>
                                            <span>{translateWord('Buy')}</span>
                                        </div>
                                        <div className="btnMovieInfo rent" onClick={() => btn_purchase_movie('Rent')}>
                                            <span>{translateWord('Rent')}</span>
                                        </div>
                                    </div>
                                    :
                                    <>
                                        <div className="play_resume_infoMovie">


                                            <div className={'btnMovieInfo icon_play'}>


                                                <div onClick={play_resume_btn}>
                                                    <img src={icon_play} alt="" />
                                                    <span>
                                                        {

                                                            movieInfo.watched ?
                                                                movieInfo.type == 'movie' ?
                                                                    translateWord('Resume') + ' (' + (Math.round(movieInfo.watched.time / 60)) + ' of ' + (movieInfo.duration || (Math.round((movieInfo.watched.time / movieInfo.watched.percent * 100) / 60))) + ' min)' :
                                                                    translateWord('Resume') + ' (S' + (season.number ? season.number : 1) + ':E' + (episode.number ? episode.number : 1) + ')'
                                                                : translateWord('Play')
                                                        }
                                                    </span>
                                                </div>
                                                {movieInfo.watched ?
                                                    <div className={'icon_refresh'} title={translateWord('Play From Beginning')}
                                                        onClick={btn_play_for_beginning}>
                                                        <img src={icon_refresh} alt="" />
                                                    </div>
                                                    : null}
                                            </div>
                                            {movieInfo.watched ?
                                                <div className="progress_info_movie">
                                                    <div className="progress_bar_info_movie"
                                                        style={{ width: `${movieInfo.watched.percent}%` }}></div>
                                                </div>
                                                : null}
                                        </div>
                                        {
                                            movieInfo.watched ? null :
                                                <div className={'btnMovieInfo btnMovieInfo_w'} onClick={btn_watch_trailer}>
                                                    <img src={icon_watch_trailer} alt="" />
                                                    <span>{translateWord('Watch Trailer')}</span>
                                                </div>
                                        }
                                    </>
                                }

                                <div className={'btnMovieInfo btnMovieInfo_w'}
                                    onClick={() => add_remove_favourites(movieInfo)}>
                                    <img src={favourite ? icon_favourites_active : icon_favourites} alt="" />
                                    {/* <span>{favourite ? translateWord('remove from favorites', 'Remove from Favourites') : translateWord('add to favorites', 'Add to Favourites')}</span> */}
                                </div>

                                {movieInfo.watched ?
                                    <div className="btnMovieInfo btnMovieInfo_w remove" onClick={btn_remove_watch_list}>
                                        <img src={icon_remove} alt="" />
                                        <span>{translateWord('Remove from watch list')}</span>
                                    </div>
                                    : null}
                            </div>
                        </div>

                        {movieInfo.not_translations && movieInfo.not_translations.length ?
                            <Notifications nots={movieInfo.not_translations} />
                            : null}

                    </div>


                </div>

                <div className="poster_image">
                    <div className="gradient_poster">

                    </div>
                    <img src={movieInfo.backdrop} alt="" />
                </div>

            </div>


            <div className={"container related_movies " + (movieInfo.not_translations && movieInfo.not_translations.length ? 'marginT' : '')}>
                {movieInfo.seasons && movieInfo.seasons.length ?
                    <div style={showListRelated ? { opacity: '0' } : null}>
                        <SeasonList seasons={movieInfo.seasons} callBackActiveSeasonIndex={callBackActiveSeasonIndex} />
                        <div id="episode_list">
                            {movieInfo.seasons[activeSeasonIndex] && movieInfo.seasons[activeSeasonIndex].episodes && movieInfo.seasons[activeSeasonIndex].episodes.length ?
                                <EpisodesList
                                    play_episode_info_field={play_episode_info_field}
                                    episodes={movieInfo.seasons[activeSeasonIndex].episodes}
                                />
                                :
                                <div className="no_episode">
                                    <h1>{translateWord('No Episodes')}</h1>
                                </div>}
                        </div>

                    </div>
                    : null}

                <div className={"related_movies_list " + (movieInfo.seasons && movieInfo.seasons.length ? 'series' : '')} style={showListRelated ? { opacity: '0' } : { opacity: '1' }}>
                    {
                        relatedMovies.map((row, rowIndex) => {
                            if (row.content.length) {
                                return <RowList
                                    key={row.id}
                                    title={row.title}
                                    type={row.type}
                                    row={row}
                                    array={row.content}
                                    rowIndex={rowIndex}
                                    isGuest={isGuest}

                                />
                            }

                        })
                    }
                </div>

            </div>

        </>
})